import { Stack } from '@mui/material';

export default function Messages({ children }) {
  return (
    <Stack
      spacing={2}
      sx={{
        p: 2,
        height: '100%',
        overflowY: 'scroll',
      }}
      direction="column-reverse"
    >
      {children}
    </Stack>
  );
}
